<template>
  <el-form-item :label="label" v-bind="$attrs">
    <el-tooltip v-if="infoText"
                :content="infoText"
                placement="bottom"
                :open-delay="300"
                popper-class="form-item__info-tooltip"
                effect="light">
      <info-icon class="a-checkbox__info-icon form-item__info-icon"/>
    </el-tooltip>
    <el-input :value="value"
              v-on="listeners"
              v-bind="{type}"
              :disabled="readonly"
              :placeholder="placeholder"
              :prefix-icon="prefixIcon"
              class="base-input"
              @input="onInput">
    </el-input>
  </el-form-item>
</template>

<script>
import { InfoIcon } from 'vue-feather-icons'
import { Tooltip } from 'element-ui'

  export default {
    name: 'base-input',
    inheritAttrs: false,
    model: {
      prop: 'value',
      event: 'input'
    },
    components: {
      InfoIcon,
      'el-tooltip': Tooltip,
    },
    props: {
      value: [String, Number],
      label: String,
      type: String,
      placeholder: String,
      prefixIcon: String,
      infoText: String,
      readonly: {
        type: Boolean,
        default: false
      },
    },
    computed: {
      listeners() {
        return {
          ...this.$listeners,
          input: this.onInput
        }
      }
    },
    methods: {
      onInput(value) {
        this.$emit('input', value)
      }
    }
  }
</script>
